import { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import Skeleton from '@components/skeletons/Skeleton';

import {
  SkeletonItemFeatureWrapper,
  SkeletonItemHeader,
  SkeletonItemMain,
  SkeletonItemWrapper,
  MobileSkeletonItemWrapper,
  MobileSkeletonItemContent,
  MobileSkeletonItemPrice,
} from './ListingSkeletonStyle';

const HotelCardSkeleton: FC = () => {
  const { xl } = useBreakpoint();
  return (
    <>
      {xl ? (
        <SkeletonItemWrapper>
          <Skeleton width={252} height={300} />

          <SkeletonItemMain>
            <SkeletonItemHeader>
              <Skeleton
                width={180}
                height={18}
                borderRadius={2}
                marginBottom={10}
              />
              <Skeleton
                width={232}
                height={23}
                borderRadius={2}
                marginBottom={10}
              />
            </SkeletonItemHeader>

            <SkeletonItemFeatureWrapper>
              {Array(3)
                .fill(0)
                .map((_, index) => (
                  <Skeleton
                    key={index}
                    width={116}
                    height={40}
                    borderRadius={2}
                    marginRight={10}
                  />
                ))}
            </SkeletonItemFeatureWrapper>
          </SkeletonItemMain>
        </SkeletonItemWrapper>
      ) : (
        <MobileSkeletonItemWrapper>
          <Skeleton height={165} />
          <MobileSkeletonItemContent>
            <Skeleton height={18} marginBottom={10} borderRadius={4} />
            <Skeleton height={24} borderRadius={4} />
          </MobileSkeletonItemContent>

          <MobileSkeletonItemPrice>
            <Skeleton width={154} height={73} borderRadius={4} />
          </MobileSkeletonItemPrice>
        </MobileSkeletonItemWrapper>
      )}
    </>
  );
};

export default HotelCardSkeleton;
